module.exports = __webpack_public_path__ + "img/mar.ia.da835d32.svg";